import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=a08a1264&scoped=true&"
import script from "./Desktop.vue?vue&type=script&lang=js&"
export * from "./Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Desktop.vue?vue&type=style&index=0&id=a08a1264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08a1264",
  null
  
)

export default component.exports